module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Section-About-2.d07c199c.png";